import React, { useState } from 'react';
import { Announcement } from '../../model/Stock';
import api, { getCombinedTicker } from '../../api/api';
import { useDispatch, useSelector } from 'react-redux';
import { IGlobalState } from '../../model/IGlobalState';
import { HasAdminRole, IsAdminOrHasRole } from '../../model/Roles';
import * as Roles from '../../model/Roles';
import ConfirmEx from '../ConfirmEx';
import AlertEx from '../AlertEx';
import { startSetStock } from '../../actions/CurrentStock';
import { FaCaretDown } from 'react-icons/fa';
import { EmailMarketingProviderType } from '../../model/EmailMarketingProviderType';


interface IProps {
    announcement: Announcement;
    onAnnouncementEdit:(announcement:Announcement)=>void;
}

const AnnouncementMenu: React.FC<IProps> = (props: IProps) => {

    const user = useSelector((state: IGlobalState) => state.user)
    const stock = useSelector((state: IGlobalState) => state.currentStock)
    const dispatch = useDispatch();
    const [menuVisible, setMenuVisible] = useState<boolean>(false);
    const [sendingEmail, setSendingEmail] = useState<boolean>(false);
    const [tagInput, setTagInput] = useState<string>('');
    const [savingTag, setSavingTag] = useState<boolean>(false);

    const TAG_MAX_LENGTH = 20;

    const onAddTag = async (): Promise<void> => {
        const raw = tagInput.trim();
        if (!raw) return;
        const existing = props.announcement.tags || [];
        if (existing.some(t => t.toLowerCase() === raw.toLowerCase())) {
            setTagInput('');
            return;
        }
        if (!props.announcement.sendGuid) {
            AlertEx('This announcement has no sendGuid yet — cannot tag.');
            return;
        }
        setSavingTag(true);
        const next = [...existing, raw];
        const result = await api().updateAnnouncementTags(getCombinedTicker(stock), props.announcement.sendGuid, next);
        setSavingTag(false);
        if (result.success) {
            setTagInput('');
            dispatch(startSetStock(getCombinedTicker(stock)));
        } else {
            AlertEx(result.errorMessage || 'Failed to save tag');
        }
    }
    
    const toggleMenu = (): void => {
        setMenuVisible(!menuVisible)
    }
    

      const onDelete = async (announcement:Announcement) : Promise<void> => {
        
                
        if (await ConfirmEx('You are about to delete an announcement for ' + stock.ticker)) {
            let result = await api().deleteAnnouncement(getCombinedTicker(stock), announcement);
            console.log('result', result)
            if(result.success){
                window.location.reload();
            }else{
                alert(`Error deleting announcement: ${result.errorMessage}`)
            }
            
        }
    }

    const sendConfirmationEmail = async (ann: Announcement): Promise<void> => {
        const send = await ConfirmEx(`Send the announcement  confirmation email to  ${stock.confirmationEmail}`);
        if(send){
            let apiResult = await api().sendConfirmationAnnouncementEmail(getCombinedTicker(stock), ann)

            if (apiResult.success) {
                
                AlertEx('Sent!');
            }
            else {
                AlertEx(apiResult.errorMessage);
            }
        }
    }

    const onSendEmail = async (ann: Announcement): Promise<void> => {

        let sendOverride = false;
        if (ann.sent) {
            
            if(!HasAdminRole(user)){
                AlertEx('This announcement has already been sent. To prevent unintentional duplicates resending is disabled. Please contact support if you wish to resend');
                return;
            }
            const result:boolean = await ConfirmEx('You have already sent this announcement! Please confirm you wish to re-send')
            if (!result)
                return;
            sendOverride = true;
        }
        
        let sendAnnouncement = false;
        if(!sendOverride){
            sendAnnouncement = await ConfirmEx(`You are manually sending an announcement for ${stock.ticker}`);
        }
        
        if (sendAnnouncement || sendOverride) {
            setSendingEmail(true)
            const combinedTicker = getCombinedTicker(stock);
            let apiResult = await api().sendAnnouncement(combinedTicker, ann, sendOverride)

            if (apiResult.success) {
                // const newStock = { ...stock };
                // let sentAnnouncement = stock.announcements.find(x => x.headline === ann.headline && x.date === ann.date);
                // sentAnnouncement!.sent = true;
                // setStock(newStock);
                dispatch(startSetStock(combinedTicker))
                AlertEx('Sent!');
            }
            else {
                AlertEx(apiResult.errorMessage);
            }
            setSendingEmail(false)
        }
    }

      const onAnnouncementAction = async (announcement:Announcement, action:AnnouncementAction) =>{
        if(action==='delete'){
            await onDelete(announcement)
        }else if(action==='sendEmail'){
            await onSendEmail(announcement)
        } else if(action==='sendConfirmationEmail'){
            await sendConfirmationEmail(announcement)
        } else if(action === 'edit'){
            await props.onAnnouncementEdit(announcement);
        }
    }
    return <div className="announcement-row__menu">
    <button className="announcement-actions-button" onClick={toggleMenu}>
        <FaCaretDown /></button>

    { menuVisible && <>
    
    <button className="button-sm" onClick={(e) => onAnnouncementAction(props.announcement, "edit")}>Edit</button>
    { stock.emailMarketingProviderType === EmailMarketingProviderType.Maileroo && <button className="button-sm" onClick={(e) => window.location.href = `/EditAnnouncementCampaign/${getCombinedTicker(stock)}/${props.announcement.sendGuid}`}>Edit Campaign</button>}
    { IsAdminOrHasRole(user, stock.id, Roles.SendMailchimp) && <button className="button-sm"
    disabled={sendingEmail}
    onClick={(e) =>
        onAnnouncementAction(props.announcement, "sendEmail")}>
        { sendingEmail ? 'Sending...' : 'Send Email '}
        </button>}
    { HasAdminRole(user) && <button className="button-sm" onClick={(e) => onAnnouncementAction(props.announcement, "sendConfirmationEmail")}>Send Confirmation Email</button>}
    {!props.announcement.deletedOn && <button className="button-sm" onClick={(e) => onAnnouncementAction(props.announcement, "delete")}>Delete</button>}
    <div className="announcement-row__tag-input">
        <input
            type="text"
            value={tagInput}
            maxLength={TAG_MAX_LENGTH}
            placeholder="Add tag"
            disabled={savingTag}
            onChange={(e) => setTagInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); onAddTag(); } }} />
        <button className="button-sm" disabled={savingTag || !tagInput.trim()} onClick={onAddTag}>{savingTag ? 'Saving...' : 'Add'}</button>
    </div>
</>}
    
</div>
}

export default AnnouncementMenu;

export type AnnouncementAction = "delete" | "edit" | "sendEmail" | "sendConfirmationEmail"